import React from 'react'
import Image from "../../../components/image"
import '../styles/IconWithLabel_style.css'

export default function IconWithLabel({ icon, label }) {

  return (
    <div className="career-icon-container">
      {/* Image */}
      <Image src={icon} alt="img" className="career-icon" />
      {/* label */}
      <p className="career-icon__label">{label}</p>
    </div>
  )

}
